import { useQuery } from 'react-query';

import { useApi } from '../../context/ApiContext';

export const useGetHistoric = (params) => {
  const client = useApi();

  return useQuery('get-historic', () => client.get(`/optimizationHistory/search?${params}`).then((res) => res.data));
};
